import styled from 'styled-components';

import { Icon } from '@material-ui/core';
import { QuizIcon } from 'pages/ListerVehicleUploadV2/icons/quizIcon';
import { useTakeNextHandler } from '../takeNext';
import { useCameraViewContext } from '../../context';

const MuiIcon = styled(Icon)`
  color: #fff;
`;

export const QuestionsIcon = () => {
  const { openConfirmDialog, currentImageSrc, recordedChunks, state, type } = useCameraViewContext();
  const saveImage = useTakeNextHandler({ switchToCameraView: false });
  const handleClick = async () => {
    if ((recordedChunks.length > 0 || currentImageSrc) && state === 'confirming_photo') {
      const response = await saveImage();
      if (response && response.loading) return;
    }
    openConfirmDialog();
  };

  if (type === 'initial_image') return null

  return (
    <MuiIcon onClick={handleClick}>
      <QuizIcon />
    </MuiIcon>
  );
};
